import '../css/slider.css';
import React from 'react';
import ReactDOM from 'react-dom';

var Slider = React.createClass({
  getDefaultProps() {
    return {
      loop: false,
      selected: 0,
      showArrows: true,
      showNav: true,
    };
  },

  getInitialState() {
    return {
      allowSliding: true,
      dragStart: 0,
      dragStartTime: new Date(),
      index: 0,
      lastIndex: 0,
      transition: false,
    };
  },

  componentWillMount() {
    const { selected } = this.props;

    this.setState({
      index: selected,
      lastIndex: selected,
    });
  },

  componentWillReceiveProps(nextProps) {
    const { selected } = this.props;

    if (selected !== nextProps.selected) {
      this.goToSlide(nextProps.selected);
    }
  },

  getDragX(event, isTouch) {
    return isTouch ?
      event.touches[0].pageX :
      event.pageX;
  },
  getDragY(event, isTouch) {
    return isTouch ?
      event.touches[0].pageY :
      event.pageY;
  },

  handleDragStart(event, isTouch) {
    const x = this.getDragX(event, isTouch);
    const y = this.getDragY(event, isTouch);

    this.setState({
      allowSliding: true,
      touchPositionY: y,
      dragStart: x,
      dragStartTime: new Date(),
      transition: false,
      slideWidth: ReactDOM.findDOMNode(this.refs.slider).offsetWidth,
    });
  },

  handleDragMove(event, isTouch) {
    const {
      touchPositionY,
      dragStart,
      lastIndex,
      slideWidth,
    } = this.state;

    const x = this.getDragX(event, isTouch);
    const y = this.getDragY(event, isTouch);


    const offset = dragStart - x;
    const percentageOffset = offset / slideWidth;
    let newIndex = lastIndex + percentageOffset;
    const SCROLL_OFFSET_TO_STOP_SCROLL = 30;

    if (Math.abs(offset) > SCROLL_OFFSET_TO_STOP_SCROLL) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (Math.abs(touchPositionY-y) >= 5 && Math.abs(offset) < 10 ) {
      newIndex = lastIndex
      this.setState({allowSliding: false})
    }

    if (this.state.allowSliding) {
      this.setState({
        index: newIndex,
      });
    }

  },

  handleDragEnd() {
    const {
      children,
    } = this.props;
    const {
      dragStartTime,
      index,
      lastIndex,
    } = this.state;

    const timeElapsed = new Date().getTime() - dragStartTime.getTime();
    const offset = lastIndex - index;
    const velocity = Math.round(offset / timeElapsed * 10000);



    let newIndex = Math.round(index);

    if (Math.abs(velocity) > 5) {
      newIndex = velocity < 0 ? lastIndex + 1 : lastIndex - 1;
    }

    if (newIndex < 0) {
      newIndex = 0;
    } else if (newIndex >= children.length) {
      newIndex = children.length - 1;
    }

    this.setState({
      dragStart: 0,
      index: newIndex,
      lastIndex: newIndex,
      transition: true,
    });
  },

  goToSlide(index, event) {
    const {
      children,
      loop,
    } = this.props;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (index < 0) {
      index = loop ? children.length - 1 : 0;
    } else if (index >= children.length) {
      index = loop ? 0 : children.length - 1;
    }

    this.setState({
      index: index,
      lastIndex: index,
      transition: true,
    })
  },

  renderNav() {
    const { children } = this.props;
    const { lastIndex } = this.state;

    const nav = children.map((slide, i) => {
      const buttonClasses = i === parseInt(lastIndex) ? 'Slider-navButton Slider-navButton--active' : 'Slider-navButton';

      return (
        <button
          className={ buttonClasses }
          key={ i }
          onClick={ (event) => this.goToSlide(i, event) } />
      );
    })

    return (
      <div className='Slider-nav'>{ nav }</div>
    );
  },

  renderArrows() {
    const {
      children,
      loop,
      showNav,
    } = this.props;
    const { lastIndex } = this.state;

    if (this.props.naviType === "mobile") {
      return (
        <div className={ showNav ? 'Slider-arrows' : 'Slider-arrows Slider-arrows--noNav' }>
            { loop || lastIndex > 0 ?
              <button
                className='Slider-arrow Slider-arrow--left'
                onClick={ (event) => this.goToSlide(parseInt(lastIndex) - 1, event) } /> : null }
            { loop || lastIndex < children.length - 1 ?
              <button
                className='Slider-arrow Slider-arrow--right'
                onClick={ (event) => this.goToSlide(parseInt(lastIndex) + 1, event) } /> : null }
          </div>
      )
    } else {
      return (
        <div>
          { loop || lastIndex > 0 ?
            <div className="arrow-exhibitions">
            <div role="button"
              className='carousel-control carousel-control-prev'
              onClick={ (event) => this.goToSlide(parseInt(lastIndex) - 1, event) } >
            <i className="fa fa-chevron-left fa-3x" aria-hidden="true"></i></div>
            </div> : null }
          { loop || lastIndex < children.length - 1 ?
            <div className="arrow-exhibitions"><div
              role="button"
              className='carousel-control carousel-control-next'
              onClick={ (event) => this.goToSlide(parseInt(lastIndex) + 1, event) } >
            <i className="fa fa-chevron-right fa-3x" aria-hidden="true"></i></div>
            </div> : null }
        </div>
      )
    }
  },

  render() {
    const {
      children,
      showArrows,
      showNav,
    } = this.props;

    const {
      index,
      transition,
    } = this.state;
    const slidesStyles = {
      width: `${ 100 * children.length + 3}%`,
      transform: `translateX(${ -1 * index * (100 / children.length) }%)`,
    };
    const slidesClasses = transition ? 'Slider-slides Slider-slides--transition' : 'Slider-slides';

    return (
      <div className='Slider' ref='slider'>
        { showArrows ? this.renderArrows() : null }
        { showNav ? this.renderNav() : null }

        <div
          className='Slider-inner'
          onTouchStart={ (event) => this.handleDragStart(event, true) }
          onTouchMove={ (event) => this.handleDragMove(event, true) }
          onTouchEnd={ () => this.handleDragEnd(true) }>
          <div
            className={ slidesClasses }
            style={ slidesStyles }>
            { children }
          </div>
        </div>
      </div>
    );
  }
});

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.jsx